"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.IconStyled = exports.Content = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _Icon = _interopRequireDefault(require("../Icon"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var Container = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  border        : ", ";\n  border-radius : ", "px;\n  display       : ", ";\n  flex-direction: ", ";\n  max-width     : ", ";\n  padding      : ", "px;\n\n  ", "\n"])), function (props) {
  return props.type ? "solid 1px ".concat(_palette.palette[props.type]) : "solid 1px ".concat(_palette.palette.bobBlack);
}, _widths.widths.base, function (props) {
  return props.visible ? 'flex' : 'none';
}, function (props) {
  return props.flexDirection;
}, function (props) {
  return props.width ? typeof props.width === 'string' ? "".concat(props.width) : "".concat(props.width, "px") : '100%';
}, _widths.widths.base * 2, function (props) {
  return props.arrow && "\n    position  : relative;\n\n    &:before {\n      background   : ".concat(_palette.palette.white, ";\n      border-bottom: solid 1px ").concat(_palette.palette[props.type] || _palette.palette.bobBlack, ";\n      border-left  : solid 1px ").concat(_palette.palette[props.type] || _palette.palette.bobBlack, ";\n      border-radius: 3px;\n      bottom       : -4px;\n      content      : \"\";\n      height       : ").concat(_widths.widths.base * 2, "px;\n      left         : 50%;\n      position     : absolute;\n      transform    : rotateZ(-45deg) translateX(-50%);\n      width        : ").concat(_widths.widths.base * 2, "px;\n    }\n  ");
});

exports.Container = Container;
Container.displayName = 'Container';

var Content = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  align-self   : center;\n  color        : ", ";\n  font-size    : 12px;\n  font-weight  : ", ";\n  padding-right: ", "px;\n"])), function (props) {
  return _palette.palette[props.type] || _palette.palette.bobBlack;
}, _widths.font.medium, _widths.widths.base * 2);

exports.Content = Content;
Content.displayName = 'Content';
var IconStyled = (0, _styledComponents["default"])(_Icon["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: auto;\n  margin-top: auto;\n"])));
exports.IconStyled = IconStyled;
IconStyled.displayName = 'IconStyled';

var Title = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  color         : ", ";\n  font-size     : 16px;\n  font-weight   : ", ";\n  letter-spacing: normal;\n  line-height   : 1.38;\n  padding-right : ", "px;\n  text-align    : left;\n  width         : 90%;\n"])), function (props) {
  return _palette.palette[props.type] || _palette.palette.bobBlack;
}, _widths.font.semi, _widths.widths.base * 2);

exports.Title = Title;
Title.displayName = 'Title';